<template>
  <div class="login_header" v-if="!this.isPopFrame">
    <div class="login_logo">
      <a :href="logoUrl">
        <img :src="loginSource['logo-' + setTheme]" alt="logo">
      </a>
    </div>
    <div class="login_bg"></div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'loginHeader',
  components: {},
  data () {
    return {
      logoUrl: '',
      setTheme: ''
    }
  },
  created () {
    this.setTheme = document.querySelector('html').getAttribute('data-theme')
    this.logoUrl = this.$urls.dtranxUrl
    if (this.loginSource.url && this.loginSource.source) {
      this.logoUrl = new URL(this.loginSource.url).href
    }
  },
  methods: {
  },
  computed: {
    ...mapState({
      isPopFrame: state => state.publicModules.isPopFrame,
      loginSource: state => state.publicModules.loginSource
    })
  }
}
</script>

<style scoped lang="scss">
.login_header{
  .login_logo{
    padding: 16px 40px;
    img{
      height: 36px;
    }
  }
}
@media (min-width: 500px) {
  .login_header{
    position: absolute;
    top: 0;
    left: 0;
    .login_bg{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      background-image: url("~@/assets/img/home-bg.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
}
@media (max-width: 499px) {
  .login_header{
    .login_bg{
      display: none;
    }
  }
}
</style>
